/* ============================================================
   ei-add-btn.js — CTA signature EI : ajout panier AJAX + états
   Chantier 1 / Brief refonte navigation 2026-07-11

   - Délégation en phase CAPTURE sur document -> seul handler du clic
     (évite le legacy ajaxCart qui redirige vers /cart).
   - Intègre le panier EI existant : window.eiCartPopover.open('extended')
     (rafraîchit le compteur .enj-cartcount). Fallback /cart.js si absent.
   - État « Ajouté » persiste jusqu'à navigation (arbitrage #2, 2026-07-11).
   - GA4 : event 'ei_add_to_cart' (ei_source / ei_size / ei_product / ei_position).
   ============================================================ */
(function () {
  'use strict';

  var ADDED_RESET = false; /* arbitrage #2 : false = persiste jusqu'à navigation */

  function ga4(btn) {
    window.dataLayer = window.dataLayer || [];
    var m = btn.className.match(/ei-add-btn--(\w+)/);
    window.dataLayer.push({
      event: 'ei_add_to_cart',
      ei_source: btn.dataset.source || 'unknown',
      ei_size: (m && m[1]) || 'md',
      ei_product: btn.dataset.handle || '',
      ei_position: parseInt(btn.dataset.position || '0', 10),
      /* Remise à zéro : la couche de données conserve les valeurs d'un push à
         l'autre (voir la note dans ei-burger-menu.js). */
      ei_action: undefined,
      ei_query: undefined,
      ei_result_type: undefined,
      ei_rayon: undefined,
      ei_sav_item: undefined
    });
  }

  function updateBadgeFallback() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document
          .querySelectorAll('.enj-cartcount, .count_pr_incart, [data-cart-count], .js-number-cart, .number-cart')
          .forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  function onClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ei-add-btn') : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add ' + res.status);
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        ga4(btn);
        document.dispatchEvent(new CustomEvent('ei:cart:updated'));
        /* Si le clic vient du burger OUVERT : fermer le tiroir pour que le
           panier pop-up passe DEVANT (sinon collision / pop-up derrière). */
        var drawer = document.getElementById('ei-burger-drawer');
        var burgerOpen = drawer && drawer.classList.contains('is-open');
        if (burgerOpen && window.EIBurgerMenu && typeof window.EIBurgerMenu.close === 'function') {
          window.EIBurgerMenu.close();
        }
        setTimeout(function () {
          if (window.eiCartPopover && typeof window.eiCartPopover.open === 'function') {
            var p = window.eiCartPopover;
            /* refresh() recharge le contenu du panier AVANT d'afficher le pop-up
               -> plus de « panier vide » le temps que l'ajout se reflète. */
            if (typeof p.refresh === 'function') {
              Promise.resolve(p.refresh()).then(function () { p.open('extended'); });
            } else {
              p.open('extended');
            }
          } else {
            updateBadgeFallback();
          }
        }, burgerOpen ? 130 : 0);
        /* Bouton du burger : ne pas laisser le ✓ figé quand on rouvre le menu */
        if (ADDED_RESET || btn.dataset.source === 'burger') {
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 1800);
        if (window.console) console.error('[ei-add-btn]', err);
      });
  }

  document.addEventListener('click', onClick, true); /* true = phase capture */
})();
